<div class="save-pending-banner" *ngIf="ShowSave()">
    <div class="save-pending-banner__content">
        <span class="save-pending-banner__icon" aria-hidden="true">
            <i class="pi pi-info-circle"></i>
        </span>
        <span class="save-pending-banner__message">
            An orange + icon means a new payroll item assignment is unsaved. Click Save to complete.
        </span>
        <button
            pButton
            type="button"
            class="save-pending-banner__action p-button-sm p-button-success"
            icon="pi pi-check"
            label="Save new items"
            title="Save new items"
            (click)="onSave(dataTable.value)"
        ></button>
    </div>
</div>

<p-table stripedRows id="dataTable"
            #dataTable
            [value]="items"
            sortField="Employeename"
            sortOrder="1"
            [customSort]="true"
            (sortFunction)="customSort($event)"
            dataKey="id"
            editMode="row"
            tableStyleClass="table"
            tableStyleClass="ui-table-medium"
            [scrollable]="true"
            scrollHeight="55vh"
        >
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7" style="text-align: center">
                        <div class="tabulator-placeholder">
                            <span> No Data Available </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="loadingbody">
                <tr>
                    <td colspan="7" style="text-align: center">
                        <div>
                            Loading...<i class="fa fa-spinner fa-spin"></i>
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="header" let-item>
                <tr>
                    <!-- Edit -->
                    <th class="edit-cell">
                    </th>
                    <!-- Status-->
                    <th class="status-cell">
                        
                    </th>                    
                    <!-- Name -->
                    <th class="p-header-cell large-cell">
                        Employee Name
                        <p-sortIcon field="EmployeeName" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                        <p-columnFilter field="EmployeeListID" matchMode="in" display="menu" [showMatchModes]="false"
                            [showOperator]="false" [showAddButton]="false" class="ml-auto">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-multiSelect
                                    fluid
                                    defaultLabel="Filter"
                                    #msPersonFilter                                        
                                    maxSelectedLabels="1"
                                    selectedItemsLabel="{0} User(s) filtered."
                                    appendTo="body"
                                    [options]="employeeSelectItems"
                                    [filter]="true"
                                    [ngModel]="value"
                                    (ngModelChange)="filter($event)"
                                ></p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <!-- User Type -->
                    <th class="p-header-cell large-cell">
                        Employee Type
                        <p-sortIcon
                            pSortableColumn="Usertype"
                            field="Usertype"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"
                        ></p-sortIcon>
                    </th>
                    <!-- Payroll Item -->
                    <th class="p-header-cell large-cell">
                        Payroll Item
                        <p-sortIcon
                            pSortableColumn="Payrollitem"
                            field="Payrollitem"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"
                        ></p-sortIcon>
                    </th>
                    <!-- Rate -->
                    <th class="p-header-cell large-cell">
                        Rate
                        <p-sortIcon
                            pSortableColumn="PayRate"
                            field="PayRate"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"
                        ></p-sortIcon>
                    </th>
                    <!-- Delete -->
                    <th class="p-datatable-cell small-cell delete-cell"></th>
                </tr>               
            </ng-template>
            <ng-template
                pTemplate="body"
                let-item
                let-edit="editing"
                let-ri="rowIndex"
                let-rowData
            >
                <tr
                    class="p-selectable-row p-datatable-row"
                    data-id="row-{{ item?.id }}"
                    [pEditableRow]="item"
                >
                    <!-- Edit -->
                    <td
                        style="text-align: center; vertical-align: middle"
                        class="p-datatable-cell edit-cell"
                    >
                        <div class="edit-cell__actions">
                            <!-- for a new row -->
                            <button
                                *ngIf="item?.id === 'add' && !editing && !edit"
                                pButton
                                type="button"
                                pInitEditableRow
                                icon="pi pi-plus"
                                class="p-button-rounded p-button-text p-button-success"
                                (click)="onRowEditInit(item)"
                                title="Add"
                            ></button>
                            <button
                                *ngIf="
                                    !edit &&
                                    (!editing?.id ||
                                        editing?.id === item?.id) &&
                                    item.id !== 'add' &&
                                    showPayRateEditButton(item)
                                "
                                pButton
                                type="button"
                                pInitEditableRow
                                icon="pi pi-pencil"
                                class="p-button-rounded p-button-text"
                                (click)="onRowEditInit(item)"
                                title="Edit"
                            ></button>
                            <button
                                *ngIf="edit"
                                [disabled]="!(item?.PayRate > 0)"
                                pButton
                                type="button"
                                pSaveEditableRow
                                icon="pi pi-check"
                                class="p-button-rounded p-button-text p-button-success"
                                (click)="onRowEditSave(item)"
                                title="Save"
                            ></button>
                            <button
                                *ngIf="edit"
                                pButton
                                type="button"
                                pCancelEditableRow
                                icon="pi pi-times"
                                class="p-button-rounded p-button-text p-button-danger"
                                (click)="onRowEditCancel(item)"
                                title="Cancel"
                            ></button>
                        </div>
                    </td>
                    <!-- Status-->
                    <td class="p-datatable-cell status-cell">
                        <div (click)="onStatusClick(item)" class="status-cell">
                            <ef-status-icon
                                [status]="item?.Status?.StatusCode"
                                [message]="item?.Status?.Message"
                            ></ef-status-icon>
                        </div>
                    </td>                    
                    <!-- Name -->
                    <td class="p-datatable-cell large-cell disabled">
                        {{ item?.Employeename }}
                    </td>
                    <!-- User Type -->
                    <td class="p-datatable-cell large-cell disabled">
                        {{ item?.Usertype }}
                    </td>
                    <!-- Payroll Item-->
                    <td class="p-datatable-cell large-cell disabled">
                        <div
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    [attr.title]="item?.Payrollitem"
                                >
                                    {{ item?.Payrollitem }}
                                </div>
                    </td>
                    <!-- Rate -->
                    <td class="p-datatable-cell large-cell disabled">
                        <p-cellEditor>
                            <ng-template
                                *ngIf="!item.IsReadOnly"
                                pTemplate="input"
                            >
                                <input
                                    title="Pay Rate"
                                    pInputText
                                    [(ngModel)]="item.PayRate"
                                />
                            </ng-template>
                            <ng-template
                                *ngIf="item.IsReadOnly"
                                pTemplate="input"
                            >
                                {{ item?.PayRate }}
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ item?.PayRate }}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <!-- Delete -->
                    <td class="p-datatable-cell small-cell delete-cell">
                        <button
                            *ngIf="!item.IsReadOnly && item?.id !== 'add'"
                            title="Delete"
                            pButton
                            type="button"
                            icon="pi pi-trash"
                            class=" p-button-rounded p-button-text"
                            [ngClass]="{orange: item?.Status?.StatusCode === ResponseStatus.Adding, 'p-button-warning': item?.Status?.StatusCode === ResponseStatus.Adding, 'p-button-danger': item?.Status?.StatusCode !== ResponseStatus.Adding}"
                            (click)="onRowEditDelete(item)"
                        ></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
